import React from "react";
import useMessageCenter from "src/components/Messaging/useMessageCenter";
import DrawerWrapper from "src/components/MyGarage/DrawerWrapper/Blocks/DrawerWrapper";
import NoMessages from "src/components/Messaging/MessageDrawer/NoMessages";
import Messages from "src/components/Messaging/Messages/Messages";
import styled from "styled-components";
import { SecondaryButton } from "Shared/Buttons";
import Send from "src/components/icons/Send";
import { darken } from "@material-ui/core/styles/colorManipulator";

const MessageCenterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    left: 0;
    top: 0;
    right: 0;
`;

const MessageWrapper = styled.div`
    padding: 1rem 24px 24px;
    flex-basis: 200px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-shrink: 0;
`;

const MessageTextArea = styled.textarea`
    height: 75%;
    padding: 10px;
    resize: none;
`;

const SendIcon = styled(Send)`
    width: 40px;
    height: 40px;
`;

const ButtonText = styled("span")`
    color: ${(props) => props.theme.palette.cta.text};
`;

const SendButton = styled(SecondaryButton)`
    padding: 0;
    color: ${(props) => props.theme.palette.cta.background};

    :hover {
        color: ${(props) => darken(props.theme.palette.cta.background, 0.08)};
    }
`;

export const MessageDrawer = () => {
    const { loaded, hasMessages, message, messages, sending, failed, change, send, retry } = useMessageCenter();

    return (
        <DrawerWrapper title={`Message Center`}>
            <MessageCenterWrapper>
                {hasMessages ? (
                    <Messages messages={messages} sending={sending} failed={failed} retry={retry} />
                ) : (
                    <NoMessages loaded={loaded} />
                )}

                <MessageWrapper>
                    <MessageTextArea value={message} onChange={change} placeholder={"Your message here..."} />
                    <SendButton onClick={send}>
                        <SendIcon />
                        <ButtonText>Send</ButtonText>
                    </SendButton>
                </MessageWrapper>
            </MessageCenterWrapper>
        </DrawerWrapper>
    );
};

export default MessageDrawer;
